/** Find name from url query @example `?redirectingPartnerName=${name}` */
export const getRedirectingPartnerName = () => {
  const redirectingPartnerNameByUrl = new URLSearchParams(window.location.search).get('redirectingPartnerName');
  redirectingPartnerNameByUrl !== null && sessionStorage.setItem('redirectingPartnerName', redirectingPartnerNameByUrl);
  const name = sessionStorage.getItem('redirectingPartnerName');

  return {
    redirectingPartnerName: name ?? undefined,
  };
};
